/**
 * ページ内リンク（アンカーリンク）のスムーズスクロール
 * URLにハッシュを追加せずにスクロールのみ実行
 */
export const anchorLink = () => {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const href = link.getAttribute('href');

    // href="#" または href="" の場合は何もしない
    if (!href || href === '#') return;

    // デフォルトの動作（URLにハッシュを追加）をキャンセル
    e.preventDefault();

    // ターゲット要素を取得
    const targetId = href.substring(1); // '#' を除去
    const targetElement = document.getElementById(targetId);

    if (!targetElement) {
      console.warn(`Target element not found: #${targetId}`);
      return;
    }

    // ヘッダーの高さを取得
    const headerHeight = document.querySelector('.header-wrap')?.offsetHeight || 0;

    // スクロール位置を計算
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;

    // スムーズスクロール
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  });
};
